import { defineStore, acceptHMRUpdate } from 'pinia';
import { url } from '@/conf/conf.js';
import { middleware } from "@/services/api/Middleware.js";
import { useDealersSorter } from '@/composables/useDealerSorter.js';
import { useAppointmentStore } from '@/stores/appointment.js';
export const useOrganizationStore = defineStore({
    id: "organization",
    state: () => ({
        dealersList: [],
        dealersBranchesData: [],
        organizationUsersList: [],
        organizationUsersTotal: 0,
        organizationUserslistPage: 1,
        organizationUsersPage: 1,
        organizationUserslistOffset: 1,
        isLoadingOrganizationUsers: true,
        organizationClientsIsLoading: false,
        isLoadingBranches: true,
        isLoadingKpiconfig: false,
        isLoadingBranding: false,
        organizationKpis: [],
        organizationClients: [],
        organizationClientsTotal: 0,
        organizationClientsTotalShow: 0,
        organizationClientsListPage: 1,
        organizationClientsPage: 1,
        organizationClientsMaxPages: 0,
        organizationUsersListMaxPages: 0,
    }),
    getters: {
        getOrganizationUsersMaxPages(state) {
            return state.organizationUsersListMaxPages;
        },
        getFilteredDealers(state) {
            return state.dealersList;
        },
        getDealersBranches(state) {
            return state.dealersBranchesData;
        },
        getSelectedDealer(state) {
            return state.selectedDealer;
        },
        getOrganizationUsers(state) {
            return state.organizationUsersList;
        },
        getOrganizationUsersTotal(state) {
            return state.organizationUsersTotal;
        },
        getOrganizationUserslistPage(state) {
            return state.organizationUserslistPage;
        },
        getOrganizationUsersPage(state) {
            return state.organizationUsersPage;
        },
        getOrganizationUsersLoading (state){
            return state.isLoadingOrganizationUsers;
        },
        getOrganizationBranchesLoading (state){
            return state.isLoadingBranches;
        },
        getDealersMarkersList(state) {
            return this.dealersBranchesData.map((dealer) => {
                return {
                    id: dealer.branch.id,
                    lat: parseFloat(dealer.branch.latitude),
                    lng: parseFloat(dealer.branch.longitude),
                    markerInfo: dealer,
                    template: `<div class="marker-tooltip">
                                    <div class="marker-tooltip__content">
                                        <h6 class="marker-tooltip__content__name">
                                            ${ dealer.branch.name }
                                        </h6>
                                        <div class="marker-tooltip__content__address">
                                            ${ dealer.branch.address }
                                        </div>
                                        <div class="marker-tooltip__content__postal-code">
                                            ${ dealer.branch.postal_code } ${ dealer.branch.city }
                                        </div>
                                        <div class="marker-tooltip__content__state">
                                            ${ dealer.branch.state }
                                        </div>
                                        <div class="marker-tooltip__content__telephone">
                                            ${ dealer.branch.telephone }
                                        </div>                                    
                                    </div>
                                </div>`
                }
            });
        },
        getOrganizationClientsList(state) {
            return state.organizationClients;
        },
        getOrganizationClientsLoading (state){
            return state.organizationClientsIsLoading;
        },
        getOrganizationClientsTotal(state) {
            return state.organizationClientsTotal;
        },
        getOrganizationClientsTotalShow(state) {
            return state.organizationClientsTotalShow;
        },
        getOrganizationClientslistPage(state) {
            return state.organizationClientsListPage;
        },
        getOrganizationClientsPage(state) {
            return state.organizationClientsPage;
        },
        getOrganizationClientsMaxPages(state) {
            return state.organizationClientsMaxPages;
        }         
    },
    actions: {
        async fetchOrganizationDealersBranches(params) {
            this.isLoadingBranches = true;
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    validation_key: params.k,
                    vehicle_id: params.vehicleId,
                    method: "getOrganizationDealersBranches",
                }),
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => response.json())
                .then((data) => {
                    this.dealersBranchesData = data.dealers_branches;
                    this.dealersBranchesData = this.dealersBranchesData.map((dealer) => {
                        dealer.lat = parseFloat(dealer.branch.latitude);
                        dealer.long = parseFloat(dealer.branch.longitude);
                        return dealer;
                    });
                    this.isLoadingBranches = false;
                    return data.dealers_branches;
                })
                .catch((error) => {
                    this.isLoadingBranches = false;
                });
            } catch (error) {
                this.isLoadingBranches = false;
            }
        },
        async fetchOrganizationUsers(params) {
            this.isLoadingOrganizationUsers = true;
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    method: "getOrganizationUsers",
                    validation_key: params.key,
                    limit: params.limit,
                    offset: params.offset * params.limit,
                    filter: params.filter,                      
                })
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => {
                    return response.json()
                })
                .then((data) => {
                    //add actions buttons
                    data.users.map((user) => {
                        user.linkId = {
                            "edit" : 'configuration/' + user.user_id
                        }
                    });
                    return data;
                })
                .then((data) => {
                    this.organizationUsersList = data && data.users ? data.users : [];
                    this.organizationUsersTotal = data && data.count ? data.count : 0;
                    this.isLoadingOrganizationUsers = false;
                    this.organizationUsersPage = params.offset / params.limit;
                    let count = data && data.count ? data.count : 0;
                    this.organizationUsersListMaxPages = Math.ceil(count / params.limit);
                    this.organizationUserslistPage = params.offset + 1;                    
                    return data && data.users ? data.users : [];
                })
                .catch((error) => {
                    this.isLoadingOrganizationUsers = false;
                });
            } catch (error) {
                this.isLoadingOrganizationUsers = false;
            }
        },        
        search(coords){
            const appointmentStore = useAppointmentStore();
            const { dealers, sortDealersByProximity } = useDealersSorter();
            dealers.value = this.dealersBranchesData;
            if(coords && coords.lat && coords.lng) {
                this.dealersList = sortDealersByProximity(coords.lat, coords.lng);
            }else {
                this.dealersList = this.dealersBranchesData;
            }
            if(this.dealersList.length > 0) {
                this.dealersList[0].selected = true;
                appointmentStore.changeSelectedDealer(this.dealersList[0]);
            }
        },
        async fetchOrganizationKpis(params){
            this.isLoadingKpiconfig = true;
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    validation_key: params.k,
                    organizationId: params.organizationId,
                    method: "getOrganizationKpis",
                }),
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => response.json())
                .then((data) => {
                    this.organizationKpis = data.kpis;
                    this.isLoadingKpiconfig = false;
                    return data;
                })
                .catch((error) => {
                    this.isLoadingKpiconfig = false;
                });
            } catch (error) {
                this.isLoadingKpiconfig = false;
            }
        },
        async fetchOrganizationClients(params){
            this.organizationClientsIsLoading = true;
            this.organizationClients = [];
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    validation_key: params.k,
                    limit: params.limit,
                    offset: params.offset * params.limit,
                    filter: params.filter,    
                    orderBy: params.orderBy,    
                    order: params.order,    
                    userId: params.userId,
                    method: "getOrganizationClients",
                }),
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => response.json())
                .then((data) => {
                    if(data.errors) {
                        // TODO
                        this.organizationClientsIsLoading = false;
                        return data;
                    } else if(data.clients.length>0) {
                        this.organizationClientsIsLoading = false;
                        this.organizationClientsMaxPages = Math.ceil(data.count / params.limit) - 1
                    }else {
                        this.organizationClientsIsLoading = false;
                        this.organizationClientsMaxPages = 0;
                    }
                    this.organizationClientsListPage = params.offset + 1;
                    this.organizationClientsPage = params.offset + 1;
                    this.organizationClientsTotal = data.count;
                    this.organizationClients = data.clients;
                    this.organizationClientsTotalShow = data.clients.length;
                    return data
                })
                .catch((error) => {
                    this.organizationClientsIsLoading = false;
                });
            } catch (error) {
                this.organizationClientsIsLoading = false;
            }
        },
        async updateOrganizationKpis(params){
            this.isLoadingKpiconfig = true;
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    validation_key: params.k,
                    organizationId: params.organizationId,
                    kpis: params.kpis,
                    method: "updateOrganizationKpis",
                }),
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => response.json())
                .then((data) => {
                    this.isLoadingKpiconfig = false;
                    return data;
                })
                .catch((error) => {
                    this.isLoadingKpiconfig = false;
                });
            } catch (error) {
                this.isLoadingKpiconfig = false;
            }
        },
        async getOrganizationBranding(params){
            this.isLoadingBranding = true;
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    validation_key: params.k,
                    organizationId: params.organizationId,
                    method: "getOrganizationBranding",
                }),
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => response.json())
                .then((data) => {
                    this.organizationBranding = data;
                    this.isLoadingBranding = false;
                    return data;
                })
                .catch((error) => {
                    this.isLoadingBranding = false;
                });
            } catch (error) {
                this.isLoadingBranding = false;
            }
        },    
        async getOrganizationBrandingByCode(params){
            this.isLoadingBranding = true;
            try{
                return await fetch(url,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ 
                            code: params.code, 
                            method: "getOrganizationBrandingByCode"
                        })
                    })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.errors){
                            return data;
                        }
                        this.organizationBranding = data;
                        this.isLoadingBranding = false;
                        return data
                    })
                    .catch((error) => {
                        this.isLoadingBranding = false;
                    });
            }
            catch (error) {
                this.isLoadingBranding = false;
            }
            
        },    
        async updateOrganizationBranding(params){
            this.isLoadingKpiconfig = true;
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    validation_key: params.k,
                    organizationId: params.organizationId,
                    name: params.branding.name,
                    logo: params.branding.logo,
                    secondary_logo: params.branding.secondary_logo,
                    login_logo: params.branding.login_logo,
                    login_image: params.branding.login_image,
                    color: params.branding.color,
                    secondary_color: params.branding.secondary_color,
                    tertiary_color: params.branding.tertiary_color,
                    welcome_message: params.branding.welcome_message, 
                    code: params.branding.code,
                    method: "updateOrganizationBranding",
                }),
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => response.json())
                .then((data) => {
                    this.isLoadingKpiconfig = false;
                    return data;
                })
                .catch((error) => {
                    this.isLoadingKpiconfig = false;
                });
            } catch (error) {
                this.isLoadingKpiconfig = false;
            }
        },
        async updateUserClientLinks(params){
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    validation_key: params.k,
                    clients: params.clients,
                    userId: params.userId,
                    method: "updateUserClientLinks",
                }),
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => response.json())
                .then((data) => {
                    this.isLoadingKpiconfig = false;
                    return data;
                })
                .catch((error) => {
                    this.isLoadingKpiconfig = false;
                });
            } catch (error) {
                this.isLoadingKpiconfig = false;
            }
        },
        async synchronizeClient(params){
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    validation_key: params.k,
                    vat_number: params.vat_number,
                    sync_new_vehicles: params.sync_new_vehicles,
                    method: "synchronizeClient",
                }),
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => response.json())
                .then((data) => {
                    return data;
                })
                .catch((error) => {
                });
            } catch (error) {
            }
        },
        async vehicleDealerSynchronize(params){
            let options = {
                method: "POST",
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json",
                },
                body: JSON.stringify({
                    validation_key: params.k,
                    dealer_id: params.dealer_id,
                    method: "vehicleDealerSynchronize",
                }),
            };
            try {
                return middleware(url, options, ['isTokenAlive'])()
                .then((response) => response.json())
                .then((data) => {
                    return data;
                })
                .catch((error) => {
                });
            } catch (error) {
            }
        }
    }
});


if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useOrganizationStore, import.meta.hot))
}